/**
 * @fileoverview Default ENGLISH strings for `@puffin-core/form-security`.
 * @package @puffin-core/form-security
 *
 * UNREACHABLE-MODULE-BURNDOWN-001 Q-UMB-21 (2026-09-24). `<RateLimitNotice>` is the ONE sentence a
 * throttled form shows when it refuses a submit. Before it existed, fourteen of pos-web's sixteen
 * throttled forms and prep-web's demo request refused SILENTLY — the click did nothing and nothing
 * said why — and the two that did speak carried their own copy of the component.
 *
 * `{{double}}` braces: this bundle is interpolated by the shared `createInterpolator` with the same
 * template i18next uses, so a registered and an unregistered tree render the same sentence.
 *
 * ⚠️ No plural keys, deliberately. The countdown renders a clock (`{{time}}` → `0:45`, `14:59`)
 * rather than "N seconds", and the attempts sentence puts the number after a colon — so neither
 * needs a `_one` / `_other` pair that the English degrade path (a flat key lookup) cannot select.
 */

export const DEFAULT_FORM_SECURITY_STRINGS = Object.freeze({
  /* The refusal — announced once, when the lock starts (role="alert") */
  'formSecurity.rateLimit.locked': 'Too many attempts. This form is temporarily locked.',

  /* The countdown under it (role="timer", never announced on each tick) */
  'formSecurity.rateLimit.countdown': 'You can try again in {{time}}.',

  /* The warning before the lock, on surfaces that count failures */
  'formSecurity.rateLimit.remaining': 'Attempts left before a temporary lock: {{attempts}}.',
});

export default DEFAULT_FORM_SECURITY_STRINGS;
